import {Component, NgZone, HostListener, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {MatDialog, MatSnackBar, MatSnackBarConfig} from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';

import { TranslateService } from '@ngx-translate/core';
import * as Ps from 'perfect-scrollbar';

import { MenuItems } from '../../shared/menu-items/menu-items';
import {SnackMessageComponent} from '../../shared/snack-messages/snack-message/snack-message.component';
import {UserService} from '../../shared/user/user.service';
import {SnackMessage} from '../../shared/snack-messages/snack-message.model';
import {SnackMessageService} from '../../shared/snack-messages/snack-message.service';
import {AuthService} from '../../shared/auth/auth.service';
import {
  RequestParameters
} from '../../shared/models/request-parameters/parameter.model';
import {ProfileService} from '../../profile/profile.service';
import {Profile} from '../../profile/profile.model';
import {GlobalVariable} from '../../global';
import {DialogMessageService} from '../../shared/dialog-messages/dialog-message.service';
import {DialogMessage} from '../../shared/dialog-messages/dialog-message.model';
import {DialogMessagesComponent} from '../../shared/dialog-messages/dialog-messages.component';
import {ChangePasswordDialogComponent} from '../../shared/change-password-dialog/change-password-dialog.component';
import {PlatformConfig} from '../../app-loader/platform-config';
import {ConfigLoaderService} from '../../app-loader/config-loader.service';
import {Observable} from 'rxjs/Observable';

const SMALL_WIDTH_BREAKPOINT = 960;

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('user') public user: ElementRef;
  @ViewChild('sidemenu') sidemenu;
  TEST_MODE = GlobalVariable.TEST_MODE;
  private _router: Subscription;
  private _snackMessage: Subscription;
  private _dialogMessage: Subscription;
  private mediaMatcher: any = matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`);
  private snackBarConfig: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  private dialogMessageConfig = {
    disableClose: false,
    panelClass: 'custom-overlay-pane-class',
    hasBackdrop: true,
    backdropClass: '',
    width: '50%',
    height: '500px',
    overflow: 'auto',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: null
  };

  private passwordChangeModalParameters = {
    disableClose: true,
    panelClass: 'custom-overlay-pane-class',
    hasBackdrop: true,
    backdropClass: '',
    width: '500px',
    height: '350px',
    overflow: 'auto',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: null
  };

  parameters = new RequestParameters();
  today: number = Date.now();
  url: string;
  showSettings = true;
  dark: boolean;
  boxed: boolean;
  collapseSidebar: boolean;
  compactSidebar: boolean;
  menuItemsList:  any;
  currentLang = 'fr';
  dir = 'ltr';
  sidePanelOpened;

  profile: Profile = new Profile();
  mediaBaseUrl = GlobalVariable.BASE_MEDIA_URL;
  sideMenuView = false;

  platformConfig: PlatformConfig;
  logoutTimeout: number = 15; // in minutes
  subscription: any;
  constructor(private router: Router,
              public menuItems: MenuItems,
              public translate: TranslateService,
              zone: NgZone,
              private userService: UserService,
              private snackBar: MatSnackBar,
              private snackMessageService: SnackMessageService,
              private dialog: MatDialog,
              private dialogMessageService: DialogMessageService,
              private authService: AuthService,
              private profileService: ProfileService,
              private configLoaderService: ConfigLoaderService) {

    this.platformConfig = this.configLoaderService.getPlatformConfig();

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    this.mediaMatcher.addListener(mql => {
          zone.run(() => {
            this.mediaMatcher = mql;
          });
    });

    this.profile = profileService.getProfileData();
    this.checkPasswordValidity();
    this.profileService.getProfile().subscribe(
      (profile: Profile) => {
        this.profile = profile;
        this.checkPasswordValidity();
      }
    );

    this.profileService.profile.subscribe(
      (profile: Profile) => {
        this.profile = profile;
      }
    );
    if (this.platformConfig.platform.callcenterConnectionTimeout !== null &&
      this.platformConfig.platform.callcenterConnectionTimeout !== undefined) {
      this.logoutTimeout = this.platformConfig.platform.callcenterConnectionTimeout;
    }
    this.initTimer(this.logoutTimeout);
  }

  ngOnInit(): void {
    this.menuItemsList = this.getMenu(this.childrenFilter);


    this.url = this.router.url;
    this._router = this.router.events.filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        document.querySelector('.app-inner .mat-drawer-content').scrollTop = 0;
        this.url = event.url;
        this.runOnRouteChange();
      });
    this._snackMessage = this.snackMessageService.newMessage.subscribe(
      (snackMessage: SnackMessage) => {
        this.snackBarConfig.data = snackMessage;
        this.snackBarConfig.extraClasses = [snackMessage.type];
        this.snackBar.openFromComponent(SnackMessageComponent, this.snackBarConfig);
      }
    );

    this._dialogMessage = this.dialogMessageService.newMessage.subscribe(
      (dialogMessage: DialogMessage) => {
        this.dialogMessageConfig.data = dialogMessage;
        this.dialogMessageConfig.panelClass = dialogMessage.type;
        this.dialog.open(DialogMessagesComponent, this.dialogMessageConfig);
      }
    );
  }
  @HostListener('mouseover', ['$event']) onDocummentClick(e: KeyboardEvent) {
    e.preventDefault();
    this.clearTimer();
    this.initTimer(this.logoutTimeout);
  }
  clearTimer () {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  initTimer (endTime: number) {
    const interval = 1000;
    const duration = endTime * 60;

    this.subscription = Observable.timer(0, interval)
      .take(duration)
      .subscribe(value => {},
        err => { console.log(err); },
        () => {
          this.onSignOutUser();
        });
  }
  onSignOutUser() {
    this.authService.deleteToken(this.userService.getCurrentUser().authToken.reference).subscribe(
      (response) => {
        this.userService.currentUser.next(null);
      }
    );
  }

  ngAfterViewInit(): void  {
    const elemSidebar = <HTMLElement>document.querySelector('.app-inner > .sidebar-panel');
    const elemContent = <HTMLElement>document.querySelector('.app-inner > .mat-drawer-content');

    if (this.mediaMatcher.matches && !this.isMac() && !this.compactSidebar) {
      Ps.initialize(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
      Ps.initialize(elemContent, { wheelSpeed: 2, suppressScrollX: true });
    }

    this.runOnRouteChange();
  }

  ngOnDestroy(): void  {
    this._router.unsubscribe();
    this._snackMessage.unsubscribe();
    this._dialogMessage.unsubscribe();
  }

  runOnRouteChange(): void {
    if (this.isOver()) {
      this.sidemenu.close();
    }

    if (this.mediaMatcher.matches && !this.isMac() && !this.compactSidebar) {
      const elemContent = <HTMLElement>document.querySelector('.app-inner > .mat-drawer-content');
      Ps.update(elemContent);
    }
  }

  isOver(): boolean {
    if (this.url === '/reports/commissions/show' ||
      this.url === '/reports/operations/show' ||
      this.url === '/reports/deposit-account/show') {
      return true;
    } else {
      return this.mediaMatcher.matches;
    }
  }

  isMac(): boolean {
    let bool = false;
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
      bool = true;
    }
    return bool;
  }

  menuMouseOver(): void {
    if (this.mediaMatcher.matches && this.collapseSidebar) {
      this.sidemenu.mode = 'over';
    }
  }

  menuMouseOut(): void {
    if (this.mediaMatcher.matches && this.collapseSidebar) {
      this.sidemenu.mode = 'side';
    }
  }

  updatePS(): void  {
    if (this.mediaMatcher.matches && !this.isMac() && !this.compactSidebar) {
      const elemSidebar = <HTMLElement>document.querySelector('.app-inner > .sidebar-panel');
      setTimeout(() => { Ps.update(elemSidebar); }, 350);
    }
  }

  checkPasswordValidity() {
    if (this.profile.reference !== null) {
      const daysSinceLastPasswordChange = ( (new Date()).getTime() -
       (new Date(this.profile.lastChangePassword)).getTime() ) /
        (1000 * 60 * 60 * 24);
      if ( daysSinceLastPasswordChange >
          (this.profile.callCenter ? (this.profile.callCenter.callCenterConfig.connectionDelay ?
           this.profile.callCenter.callCenterConfig.connectionDelay
            : GlobalVariable.PASSWORD_MAX_AGE) : GlobalVariable.PASSWORD_MAX_AGE ) ) {
        this.dialog.open(ChangePasswordDialogComponent, this.passwordChangeModalParameters);
      }
    }
  }

  childrenFilter(tabs: any[], perms: any[]) {
    const permissions = [];
    perms.forEach(function(permission: any) {
      if (permission) {
        permissions.push(permission.name);
      }
    });
    const tablo = tabs.filter((tab) => {
      if (!tab.permissions || tab.permissions.length === 0) {
        return true;
      }
      return permissions.includes(tab.permissions[0]);
    });
    return tablo;
  }

  getMenu(chldFilter: any) {
    const menus = this.menuItems.getAll();
    const currentUser  = JSON.parse(window.localStorage.getItem('currentUser'));
    const permissions = [];
    if (currentUser.hasOwnProperty('permissions')) {
      currentUser.permissions.forEach(function(permission: any) {
        permissions.push(permission.name);
      });
    }
    const arrayMenu = menus.filter(function(menuItem: any) {
      if ('children' in menuItem) {
        menuItem.children = chldFilter(menuItem.children, currentUser.permissions ? currentUser.permissions : []);
        return menuItem;
      } else {
        return menuItem;
      }
    });
    return arrayMenu.filter(function(menuItem: any) {
      if ('permissions' in menuItem) {
        return permissions.includes(menuItem.permissions[0]);
      } else if (('children' in menuItem) && menuItem.children.length === 0)  {
        return false;
      }  else {
        return menuItem;
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/layouts/admin/admin-layout.component.ts